module.exports = __webpack_public_path__ + "img/GT logo-RGB.b8e62f22.png";